module.exports = __webpack_public_path__ + "static/media/truba_kr.06a28453.png";